/* eslint-disable no-unused-vars */
import React, { useMemo, useState, useEffect, useContext } from 'react';
import { Box, Typography, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { toast } from 'react-toastify';
import _ from 'lodash';
import moment from 'moment';
import { param } from 'jquery';
import useManagerContext from './context/useManagerContext';
import Filter from './components/Filter';
import Table from './components/Table';
import Footer from './components/Footer';
import './components/style.css';
import useStore from '../../states/store';
import {
  getDateRange,
  getDailyManagerDashboard,
  getDailyManagerDashboardTotal,
  getManagerDashboardWorkingRerport,
  getExportManagerDashboard,
  getExportPlannedExecution,
  getAdvanceReceivedDetails,
} from '../../api/managerDashboard';
import AppConst from '../../components/AppLayout/const';
import AdvanceReceivedPopover from './components/AdvanceReceivedPopOver';

export default function ManagerDashboard() {
  const [anchorEl, setAnchorEl] = useState(null);

  const auth = useStore((state) => state.auth);
  const date = new Date();
  const monthsOptions = [
    { label: 'January', value: '1' },
    { label: 'February', value: '2' },
    { label: 'March', value: '3' },
    { label: 'April', value: '4' },
    { label: 'May', value: '5' },
    { label: 'June', value: '6' },
    { label: 'July', value: '7' },
    { label: 'August', value: '8' },
    { label: 'September', value: '9' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ];
  const yearOptions = [];

  /* eslint-disable no-plusplus */
  for (let i = 2010; i <= date.getFullYear(); i++) {
    yearOptions.push({ label: i.toString(), value: i.toString() });
  }
  const defaultFilter = {
    department: { label: 'ALL', value: null },
    team: { label: 'ALL', value: null },
    manager: '',
    field_level: { label: 'ALL', value: null },
    strat_class: '',
    focus_group: '',
    month: monthsOptions[date.getMonth()],
    year: { label: date.getFullYear().toString(), value: date.getFullYear().toString() },
    date_from: moment(`${date.getFullYear()}-${monthsOptions[date.getMonth()].value}-01`).toDate(),
    date_to: moment().format('YYYY-MM-') + moment().daysInMonth(),
    report_view: { value: 'daily', label: 'Daily' },
  };

  const defaultWorkingReport = {
    call: 0,
    call_percentage: 100,
    plan: 0,
    plan_percentage: 0,
    deviation: 0,
    deviation_percentage: 0,
    working_days: 21,
    field_days: 10,
    target: null,
    target_percentage: 0,
    mtd_date_range: 0,
    mtd_date_range_percentage: 0,
    total_md: 0,
    reach: 0,
    reach_percentage: 0,
    concentration: 0,
    concentration_percentage: 0,
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState([]);
  const [managerDashboard, setmanagerDashboard] = useState([]);
  const [workingReport, setWorkingReport] = useState(defaultWorkingReport);
  const [dropdownDisabled, setDropdownDisabled] = useState(false);
  const [advanceReceivedDetails, setAdvanceReceivedDetails] = useState({
    loading: false,
    data: [],
  });
  const { onSetTitle } = useContext(AppConst.AppContext);

  onSetTitle('Manager Dashboard');

  const loadDetails = async (params) => {
    try {
      setAdvanceReceivedDetails({ ...advanceReceivedDetails, loading: true, data: null });

      const res = await getAdvanceReceivedDetails(params);
      const { code, data } = res.data;

      if (code !== '200') throw new Error('No Data.');

      setAdvanceReceivedDetails({ ...advanceReceivedDetails, loading: false, data });
    } catch (error) {
      setAdvanceReceivedDetails({ ...advanceReceivedDetails, loading: false, data: null });
      toast.error(error.message);
    }
  };

  const handlePopoverOpen = (event, rowDetails) => {
    const currentDate = `${filterForm.year.value}-${filterForm.month.value}-${rowDetails.currentLabel}`;
    loadDetails({
      rep_id: rowDetails.rep_id,
      doctor_id: rowDetails.md_id,
      report_view: filterForm.report_view.value,
      date_from: currentDate,
      date_to: currentDate,
    });
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const loadDailyManagerDashboard = async (request) => {
    try {
      const res = await getDailyManagerDashboard(request);
      const { code, data } = res.data;

      if (code === '200') {
        const response = await getDailyManagerDashboardTotal(request);

        const totals = response.data.data;
        const totalCallsArr = [0];
        const totalPlotsArr = [0];
        const totalDailyTargetArr = [0];
        const totalPlanExecArr = [0];
        const totalVersusTargetArr = [0];
        const totalCalls = totals.map((row, i) => totalCallsArr.push(row.actual_call));
        const totalPlots = totals.map((row, i) => totalPlotsArr.push(row.plots));
        const totalDailyTarget = totals.map((row, i) => totalDailyTargetArr.push(row.daily_target));
        const totalPlanExecTarget = totals.map((row, i) =>
          totalPlanExecArr.push(`${row.plan_execution}%`),
        );
        const totalVersusTarget = totals.map((row, i) =>
          totalVersusTargetArr.push(`${row.versus_target}%`),
        );
        const totalData = [
          {
            id: 'total-1',
            rep_name: '',
            md_name: '',
            md_code: '',
            strat_class: '',
            focus_group: '',
            target: 'Actual Calls',
            ...totalCallsArr,
            total_call: '',
            rate: '',
            total_planned: '',
            total_deviation: '',
            isPinnedRows: 1,
          },
          {
            id: 'total-2',
            rep_name: '',
            md_name: '',
            md_code: '',
            strat_class: '',
            focus_group: '',
            target: 'Plots',
            ...totalPlotsArr,
            total_call: '',
            rate: '',
            total_planned: '',
            total_deviation: '',
            isPinnedRows: 1,
          },
          {
            id: 'total-3',
            rep_name: '',
            md_name: '',
            md_code: '',
            strat_class: '',
            focus_group: '',
            target: 'Daily Target',
            ...totalDailyTargetArr,
            total_call: '',
            rate: '',
            total_planned: '',
            total_deviation: '',
            isPinnedRows: 1,
          },
          {
            id: 'total-4',
            rep_name: '',
            md_name: '',
            md_code: '',
            strat_class: '',
            focus_group: '',
            target: 'Plan Execution',
            ...totalPlanExecArr,
            total_call: '',
            rate: '',
            total_planned: '',
            total_deviation: '',
            isPinnedRows: 1,
          },
          {
            id: 'total-5',
            rep_name: '',
            md_name: '',
            md_code: '',
            strat_class: '',
            focus_group: '',
            target: 'Versus Target',
            ...totalVersusTargetArr,
            total_call: '',
            rate: '',
            total_planned: '',
            total_deviation: '',
            isPinnedRows: 1,
          },
        ];

        setmanagerDashboard([...totalData, ...data]);

        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadWorkingReport = async (request) => {
    try {
      const res = await getManagerDashboardWorkingRerport(request);
      const { code, data } = res.data;

      if (code === '200') {
        setWorkingReport(data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const exporthManagerDashboard = async () => {
    try {
      toast.loading('Exporting data...');
      const request = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager?.value,
        rep_id: filterForm?.field_level?.value,
        strat_class: filterForm?.strat_class?.value,
        focus_group: filterForm?.focus_group?.value,
        month: filterForm?.month?.value,
        year: filterForm?.year?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
        report_view: filterForm?.report_view?.value,
      };
      const res = await getExportManagerDashboard(request);
      const { code, result } = res.data.response;

      if (code === '200') {
        window.location.href = result;
        toast.dismiss();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const exportPlannedExecution = async () => {
    try {
      toast.loading('Exporting data...');
      const request = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager?.value,
        rep_id: filterForm?.field_level?.value,
        strat_class: filterForm?.strat_class?.value,
        focus_group: filterForm?.focus_group?.value,
        month: filterForm?.month?.value,
        year: filterForm?.year?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
        report_view: filterForm?.report_view?.value,
      };
      const res = await getExportPlannedExecution(request);
      const { code, result } = res.data.response;

      if (code === '200') {
        window.location.href = result;
        toast.dismiss();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const searchManagerDashboard = async () => {
    try {
      setLoading(true);
      setDates([]);
      setmanagerDashboard([]);
      const request = {
        department: filterForm?.department?.value,
        team: filterForm?.team?.value,
        manager_id: filterForm?.manager?.value,
        rep_id: filterForm?.field_level?.value,
        strat_class: filterForm?.strat_class?.value,
        focus_group: filterForm?.focus_group?.value,
        month: filterForm?.month?.value,
        year: filterForm?.year?.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm?.date_to).format('YYYY-MM-DD'),
        report_view: filterForm?.report_view?.value,
      };

      const res = await getDateRange(request);
      const { code, data } = res.data;

      if (code === '200') {
        loadDailyManagerDashboard(request);
        loadWorkingReport(request);

        if (request.report_view === 'daily') {
          const dateRanges = data?.map((row) => ({
            field: row.tag.toString(),
            headerName: row.label.toString(),
            width: 30,
            renderCell: (params) => {
              if (params.value === 'Plotted/Lapsed') {
                return '';
              }

              if (params.value === 'Plotted/Upcoming') {
                return '';
              }

              if (params.value === 'Weekend') {
                return '';
              }

              if (params.value === 'As Planned') {
                return 1;
              }

              if (params.value === 'Advanced') {
                return (
                  <Typography
                    onMouseEnter={(e) =>
                      handlePopoverOpen(e, { ...params.row, currentLabel: row.label })
                    }
                    onMouseLeave={handlePopoverClose}
                    sx={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      alignItems: 'center',
                    }}
                  >
                    1
                  </Typography>
                );
              }

              if (params.value === 'Retrieved') {
                return (
                  <Typography
                    onMouseEnter={(e) =>
                      handlePopoverOpen(e, { ...params.row, currentLabel: row.label })
                    }
                    onMouseLeave={handlePopoverClose}
                    sx={{
                      display: 'flex',
                      width: '100%',
                      height: '100%',
                      alignItems: 'center',
                    }}
                  >
                    1
                  </Typography>
                );
              }

              return params.value;
            },
            cellClassName: (params) => {
              if (params.value === 'Plotted/Lapsed') {
                return 'legend-gray';
              }

              if (params.value === 'Plotted/Upcoming') {
                return 'legend-dark-gray';
              }

              if (params.value === 'As Planned') {
                if (parseFloat(params.field) <= moment(request?.date_to).format('D')) {
                  return 'legend-green';
                }
                return 'legend-gray';
              }

              if (params.value === 'Advanced') {
                if (parseFloat(params.field) <= moment(request?.date_to).format('D')) {
                  return 'legend-blue';
                }
                return 'legend-gray';
              }

              if (params.value === 'Retrieved') {
                if (parseFloat(params.field) <= moment(request?.date_to).format('D')) {
                  return 'legend-yellow';
                }
                return 'legend-gray';
              }

              if (parseFloat(params.field) <= moment(request?.date_to).format('D')) {
                return row.day === 'Sunday' || row.day === 'Saturday'
                  ? 'legend-pink'
                  : 'legend-white';
              }

              if (row.day === 'Sunday' || row.day === 'Saturday') {
                return 'legend-pink';
              }

              return 'legend-white text-gray';
            },
          }));

          setDates(dateRanges);
        }
        if (request.report_view === 'weekly') {
          const dateRanges = data?.map((row) => ({
            field: row.tag.toString(),
            // eslint-disable-next-line prefer-template
            headerName: 'Week ' + row.tag.toString(),
            width: 30,
          }));

          setDates(dateRanges);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const checkUserLevel = () => {
    // setDropdownDisabled(true);
    const kasmArr = [''];
    if (auth.level === 'Level 2') {
      const depObj =
        auth.designation === 'KASM'
          ? { value: 'KASD', label: 'KASD' }
          : { value: 'SAR', label: 'SAR' };

      setFilterForm({
        ...filterForm,
        department: depObj,
        manager: { value: auth.user_id, label: `${auth.last_name}, ${auth.first_name}` },
      });
    }
  };

  const clearManagerDashboard = () => {
    if (auth.level === 'Level 2') {
      setDropdownDisabled(true);
      const depObj =
        auth.designation === 'KASM'
          ? { value: 'KASD', label: 'KASD' }
          : { value: 'SAR', label: 'SAR' };

      const stateFilter = {
        ...defaultFilter,
        department: depObj,
        manager: { value: auth.user_id, label: `${auth.last_name}, ${auth.first_name}` },
      };

      setFilterForm(stateFilter);
    } else {
      setFilterForm(defaultFilter);
    }
  };

  useEffect(() => {
    checkUserLevel();
  }, []);

  const open = Boolean(anchorEl);

  return (
    <useManagerContext.Provider
      value={useMemo(() => ({
        auth,
        managerDashboard,
        dates,
        loading,
        setFilterForm,
        filterForm,
        monthsOptions,
        yearOptions,
        exporthManagerDashboard,
        exportPlannedExecution,
        searchManagerDashboard,
        clearManagerDashboard,
        workingReport,
        dropdownDisabled,
      }))}
    >
      <div className='body-content'>
        <Box sx={{ backgroundColor: '#fff', boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Box>
            <Box>
              <Grid container spacing={2}>
                <Grid xs={12} sm={12} md={12}>
                  <Box>
                    <Grid md={12}>
                      <Button
                        variant='contained'
                        color='warning'
                        sx={{
                          marginTop: '10px',
                          padding: 1,
                          float: 'right',
                          marginLeft: '10px',
                        }}
                        onClick={exportPlannedExecution}
                      >
                        Export Planned Execution
                      </Button>

                      <Button
                        variant='contained'
                        color='warning'
                        sx={{ marginTop: '10px', padding: 1, float: 'right' }}
                        onClick={exporthManagerDashboard}
                      >
                        Export XLSX
                      </Button>
                    </Grid>
                  </Box>
                </Grid>
                <Grid xs={12} sm={12} md={10}>
                  <Table />
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                paddingTop: '20px',
                paddingBottom: '20px',
              }}
            >
              <Grid>
                <Footer />
              </Grid>
            </Box>
          </Box>
        </Box>
      </div>
      <AdvanceReceivedPopover
        open={open}
        anchorEl={anchorEl}
        onClosePopover={handlePopoverClose}
        loading={advanceReceivedDetails.loading}
        data={advanceReceivedDetails.data}
      />
    </useManagerContext.Provider>
  );
}
